export const numHour = Array.from({ length: 24 }, (_, i) => String(i));
export const numMinute = Array.from({ length: 60 }, (_, i) => String(i));
